import React, { useState } from "react";
import { Row, Col, Typography, Menu, Dropdown, Grid } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import logo from "../assets/logo.png";
import propertyImage from "../assets/about-us.png";
import CommonFooter from "../components/common/CommonFooter";
import { Link } from "react-router-dom";
import InstantCallModal from "../components/common/InstantCallModal";

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

const OurStory = () => {
  const screens = useBreakpoint();
  const [menuVisible, setMenuVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleInstantCallClick = (e) => {
    e.preventDefault();
    setMenuVisible(false);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const menu = (
    <Menu
      theme="dark"
      style={{
        background: "rgba(0, 0, 0, 0.95)",
        color: "#fff",
        padding: screens.xs ? "8px 16px" : "10px 25px",
        borderRadius: "6px",
        minWidth: screens.xs ? "200px" : "250px",
      }}
      items={[
        {
          key: "0",
          label: (
            <Link
              to="/"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Home
            </Link>
          ),
        },
        {
          key: "1",
          label: (
            <Link
              to="/about-us"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Who we are
            </Link>
          ),
        },
        {
          key: "2",
          label: (
            <Link
              to="/listed-property"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Our offerings
            </Link>
          ),
        },
        {
          key: "3",
          label: (
            <Link
              to="/work"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              How NITM works
            </Link>
          ),
        },
        {
          key: "4",
          label: (
            <Link
              to="/policy"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              List your Property
            </Link>
          ),
        },
        {
          key: "5",
          label: (
            <Link
              to="/news-room"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              News Room
            </Link>
          ),
        },
        {
          key: "6",
          label: (
            <Link
              to="/contact-us"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Contact Us
            </Link>
          ),
        },
        {
          key: "7",
          label: (
            <Link
              to="/our-story"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Our Story
            </Link>
          ),
        },
        // Instant Call Button - Added from common header
        {
          key: "instant-call",
          label: (
            <div
              onClick={handleInstantCallClick}
              style={{
                color: "#EDC71C",
                padding: "12px 16px",
                marginTop: "10px",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: screens.xs ? "12px" : "14px",
                cursor: "pointer",
                background: "transparent",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              Instant Call
            </div>
          ),
        },
      ]}
    />
  );

  return (
    <div style={{ minHeight: "100vh", background: "#f0f0f0" }}>
      <Row style={{ minHeight: "100vh" }}>
        {/* Left Image Section */}
        {screens.md && (
          <Col md={12} style={{ position: "relative" }}>
            <img
              src={propertyImage}
              alt="Property"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: screens.xs ? "12px" : "0 0 140px 0",
              }}
            />
            <Link to="/" style={{ display: "inline-block" }}>
              <img
                src={logo}
                alt="Logo"
                style={{ position: "absolute", top: 20, left: 20, height: 40 }}
              />
            </Link>
          </Col>
        )}

        {/* Mobile Logo - Top left on mobile */}
        {!screens.md && (
          <div style={{ position: "absolute", top: 20, left: 20, zIndex: 10 }}>
            <Link to="/" style={{ display: "inline-block" }}>
              <img
                src={logo}
                alt="Logo"
                style={{
                  height: screens.xs ? "50px" : "60px",
                }}
              />
            </Link>
          </div>
        )}

        {/* Right Section */}
        <Col
          xs={24}
          md={12}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            background: "#f0f0f0",
            minHeight: "100vh",
          }}
        >
          {/* Header */}
          <div
            style={{
              width: "100%",
              background: "#DDC7BB",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: screens.xs ? "60px" : "80px",
            }}
          >
            <Dropdown
              overlay={menu}
              placement="bottomRight"
              trigger={screens.xs ? ["click"] : ["hover"]}
              open={menuVisible}
              onOpenChange={setMenuVisible}
            >
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#8f8c8c",
                  padding: screens.xs ? "0 12px" : "0 16px",
                  cursor: "pointer",
                }}
              >
                <MenuOutlined
                  style={{
                    color: "#fff",
                    fontSize: screens.xs ? 16 : 20,
                  }}
                />
              </div>
            </Dropdown>
          </div>

          {/* Our Story Content */}
          <div
            style={{
              marginTop: screens.xs ? 40 : 60,
              width: "100%",
              maxWidth: 700,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: screens.xs ? "0 20px" : "0 40px",
            }}
          >
            <Title
              level={screens.xs ? 3 : 2}
              style={{
                color: "#000",
                marginBottom: 20,
                fontFamily: "Playfair Display, serif",
                fontWeight: "700",
                fontSize: screens.xs ? "24px" : "32px",
              }}
            >
              Our Story
            </Title>

            <Paragraph
              style={{
                fontSize: screens.xs ? 14 : 16,
                color: "#444",
                lineHeight: 1.8,
                textAlign: screens.xs ? "justify" : "left",
                whiteSpace: "pre-line",
              }}
            >
              It began with a simple realization — the property market had
              become fragmented. Extended broker chains, unreliable information
              and inconsistent deal flows were costing everyone valuable
              opportunities. We knew there had to be a better way.
              {"\n\n"}
              So, we set out to rethink the model. The result was a verified,
              homegrown network built on trust — connecting genuine buyers
              directly with real property owners. Every transaction on our
              platform is anchored in accuracy, integrity and efficiency.
              {"\n\n"}
              Our mission is clear: to simplify real estate through transparency
              and technology, empowering our clients with fast, verified and
              confidential access to genuine opportunities.
              {"\n\n"}
              notinthemarket.com isn't just another property platform — it's
              where serious business meets trust. We value time, respect
              privacy, and believe that every deal should begin and end with
              authenticity.
            </Paragraph>
          </div>
        </Col>
      </Row>

      <CommonFooter />


      <InstantCallModal
        visible={isModalVisible}
        onClose={handleModalClose}
        propertyId={null}
      />
    </div>
  );
};

export default OurStory;
